import React, { useState, useEffect } from 'react';
import { ThrowableIcon } from './IconPlayground';

const IconOrList = ({ group = 'icons', ...icons }) => {
  const names = icons.icons.map(obj => obj.name);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 951);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 951);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div>
      {isMobile ? (
        <p className="text-center lg:text-left lg:pt-1">{names.join(' · ')}</p>
      ) : (
        <div className="flex flex-wrap justify-start gap-x-6 gap-y-4">
          {icons.icons.map((icon) => (
            <div key={icon.id} className="flex flex-col items-center w-20">
              <div className="h-14 w-14 flex items-center justify-center [&>img]:max-h-full [&>img]:max-w-full">
                <ThrowableIcon id={`${group}-${icon.id}`} icon={icon} />
              </div>
              <span className="pt-2 text-sm text-[#555] dark:text-[#c9cfe3] text-center leading-tight">{icon.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default IconOrList;